import React from 'react';
import Layout from '../Layout';
import TitleSection from '../TitleSection';
import '../../css/ateliers.css';

const WorkshopPage = () => {
  return (
    <Layout>
      <TitleSection title='Ateliers de Prévention'/>
      
      <div className="container my-5 ateliers-content">
        {/* Introduction section */}
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              {/* <img 
                src="/img/logo-ovlm.png" 
                alt="OVLM - On Voyage léger et malin" 
                className="img-fluid mb-4" 
                style={{ maxWidth: "250px" }}
              /> */}
              <h2 className="display-5 fw-bold mb-4">Nos conseils et ateliers de prévention</h2>
              <h3 className="mb-4 text-primary">Adoptez les bons réflexes et participez à nos ateliers 
              de prévention sur différentes thématiques pour 
              profiter pleinement de vos enfants.</h3>
              
              <div className="p-4 bg-light rounded-3 text-start">
                <p>Nous proposons aux parents ou tout autres personnes ayant en charge un enfant des ateliers de 
                prévention portant sur 2 thématiques routière et domestiques : le siège auto (en 3 volumes), 
                l'aménagement de son domicile, choix des articles etc.</p>
                
                <p>Animés par une passionnée pour des petits 
                groupes maxi 12 personnes, ces ateliers vous permettent de bénéficier de conseils adaptés et 
                d'acquérir les bons réflexes pour éviter les accidents, dans un cadre convivial et dynamique.</p>
                
                <p>Que vous soyez parents, grands-parents, nounous, tantes, oncles… la prévention est une démarche 
                essentielle, adoptez quelques bons réflexes bénéfiques pour la sécurité de l'enfant.</p>
                
                <figure className="text-center mt-4">
                  <blockquote className="blockquote">
                    <p><em>"Chaque parent vient au monde en même temps que son premier enfant"</em></p>
                  </blockquote>
                  <figcaption className="blockquote-footer">
                    Ernst Kramer
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
        
        {/* Atelier sections */}
        <div className="row mb-5">
          <div className="col-12">
            <h3 className="border-start border-5 border-primary ps-3 mb-4">Nos ateliers routiers</h3>
          </div>
        </div>
        
        {/* Workshop cards - first row */}
        <div className="row row-cols-1 row-cols-md-2 g-4 mb-5">
          {/* R01-00 */}
          <div className="col">
            <div className="card h-100 shadow-sm">
              <div className="row g-0">
                <div className="col-md-4 d-flex align-items-center p-3">
                  <img src="https://api.ovlm97.fr/uploads/Picture_1_063f054da2.jpg" className="img-fluid rounded" alt="Kit ceinture pour femme enceinte" />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title fw-bold">LA FEMME ENCEINTE EN VOITURE</h5>
                    <h6 className="card-subtitle mb-3 text-primary">REFERENCE R01-01</h6>
                    <div className="card-text">
                      <p className="fw-bold mb-2">Voici les thèmes qui seront abordés lors de l'atelier :</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">La loi, les Homologation et les normes</li>
                        <li className="list-group-item">Les statistiques</li>
                        <li className="list-group-item">Bien s'attacher</li>
                        <li className="list-group-item">Démonstration de l'installation du kit</li>
                        <li className="list-group-item">Suivi pendant 20 jours par WhatsApp – toutes vos questions concernant l'atelier</li>
                      </ul>
                    </div>
                    <div className="mt-3">
                      {/* <button className="btn btn-outline-primary">S'inscrire</button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* R01-01 */}
          <div className="col">
            <div className="card h-100 shadow-sm">
              <div className="row g-0">
                <div className="col-md-4 d-flex align-items-center p-3">
                  <img src="https://api.ovlm97.fr/uploads/Picture_2_7212fef07a.jpg" className="img-fluid rounded" alt="Siège auto cosy" />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title fw-bold">LE COSY</h5>
                    <h6 className="card-subtitle mb-3 text-primary">REFERENCE R01-01</h6>
                    <div className="card-text">
                      <p className="fw-bold mb-2">Voici les thèmes qui seront abordés lors de l'atelier :</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">La loi, les Homologation et les normes</li>
                        <li className="list-group-item">Les statistiques</li>
                        <li className="list-group-item">Choisir le bon siège</li>
                        <li className="list-group-item">Bien s'attacher</li>
                        <li className="list-group-item">Démonstration de l'installation du siège auto et de bébé dans une voiture</li>
                        <li className="list-group-item">Suivi pendant 20 jours par WhatsApp – toutes vos questions concernant l'atelier et le siège-auto cosy</li>
                      </ul>
                    </div>
                    <div className="mt-3">
                      {/* <button className="btn btn-outline-primary">S'inscrire</button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Workshop cards - second row */}
        <div className="row row-cols-1 row-cols-md-2 g-4 mb-5">
          {/* R01-02 */}
          <div className="col">
            <div className="card h-100 shadow-sm">
              <div className="row g-0">
                <div className="col-md-4 d-flex align-items-center p-3">
                  <img src="https://api.ovlm97.fr/uploads/Picture_3_cc8b5dca7d.jpg" className="img-fluid rounded" alt="Siège auto 2ème âge" />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title fw-bold">SIEGE 2EME AGE</h5>
                    <h6 className="card-subtitle mb-3 text-primary">REFERENCE R01-02</h6>
                    <div className="card-text">
                      <p className="fw-bold mb-2">Voici les thèmes qui seront abordés lors de l'atelier :</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">La loi, les Homologation et les normes</li>
                        <li className="list-group-item">Les statistiques</li>
                        <li className="list-group-item">Choisir le bon siège</li>
                        <li className="list-group-item">Bien s'attacher</li>
                        <li className="list-group-item">Démonstration de l'installation du siège auto et de bébé dans une voiture</li>
                        <li className="list-group-item">Suivi pendant 20 jours par WhatsApp – toutes vos questions concernant l'atelier et le siège auto</li>
                      </ul>
                    </div>
                    <div className="mt-3">
                      {/* <button className="btn btn-outline-primary">S'inscrire</button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* R01-03 */}
          <div className="col">
            <div className="card h-100 shadow-sm">
              <div className="row g-0">
                <div className="col-md-4 d-flex align-items-center p-3">
                  <img src="https://api.ovlm97.fr/uploads/Picture_4_7fe76ffc6d.jpg" className="img-fluid rounded" alt="Rehausseur auto" />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title fw-bold">REHAUSSEUR</h5>
                    <h6 className="card-subtitle mb-3 text-primary">REFERENCE R01-03</h6>
                    <div className="card-text">
                      <p className="fw-bold mb-2">Voici les thèmes qui seront abordés lors de l'atelier :</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">La loi, les Homologation et les normes</li>
                        <li className="list-group-item">Les statistiques</li>
                        <li className="list-group-item">Choisir le bon siège</li>
                        <li className="list-group-item">Bien s'attacher</li>
                        <li className="list-group-item">Démonstration de l'installation du siège auto et de bébé dans une voiture</li>
                        <li className="list-group-item">Suivi pendant 20 jours par WhatsApp – toutes vos questions concernant l'atelier et le réhausseur</li>
                      </ul>
                    </div>
                    <div className="mt-3">
                      {/* <button className="btn btn-outline-primary">S'inscrire</button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Domestic workshops section */}
        <div className="row mb-5">
          <div className="col-12">
            <h3 className="border-start border-5 border-primary ps-3 mb-4">Nos ateliers domestiques</h3>
          </div>
        </div>
        
        {/* Workshop cards - third row */}
        <div className="row row-cols-1 row-cols-md-2 g-4 mb-5">
          {/* D01-00 */}
          <div className="col">
            <div className="card h-100 shadow-sm">
              <div className="row g-0">
                <div className="col-md-4 d-flex align-items-center p-3">
                  <img src="https://api.ovlm97.fr/uploads/Picture_5_a6aa376f3c.jpg" className="img-fluid rounded" alt="Portage pour jumeaux" />
                </div>
                <div className="col-md-8">
                  <div className="card-body">
                    <h5 className="card-title fw-bold">LE PORTAGE DES JUMEAUX</h5>
                    <h6 className="card-subtitle mb-3 text-primary">REFERENCE D01-00</h6>
                    <div className="card-text">
                      <p className="fw-bold mb-2">Voici les thèmes qui seront abordés lors de l'atelier :</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">Sécurité</li>
                        <li className="list-group-item">Position physiologique</li>
                        <li className="list-group-item">Les différents types de portage</li>
                        <li className="list-group-item">Démonstration et essaie</li>
                        <li className="list-group-item">Suivi pendant 10 jours par WhatsApp – toutes vos questions concernant l'atelier et le portage de jumeaux</li>
                      </ul>
                    </div>
                    <div className="mt-3">
                      {/* <button className="btn btn-outline-primary">S'inscrire</button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* CTA Section */}
        <div className="row my-5">
          <div className="col-12">
            <div className="p-5 text-center bg-primary text-white rounded-3">
              <h2 className="mb-4">Prêt à participer à nos ateliers ?</h2>
              <p className="lead mb-4">Rejoignez nos ateliers de prévention en petits groupes et bénéficiez d'un suivi personnalisé</p>
              <a href="/contact" className="btn btn-light btn-lg px-4">Contactez-nous</a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WorkshopPage;